import { AfterViewInit, Component } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';
import { DateTime } from 'luxon';
import { Constants } from 'src/app/constants';

@Component({
    //   standalone: true,
    //   imports: [NgClass],
    selector: 'app-datetime-editor',
    templateUrl: './datetime-editor.component.html',
    styleUrls: ['./datetime-editor.component.scss'],
    standalone: false // NOSONAR
})
export class DateTimeEditor implements ICellEditorAngularComp, AfterViewInit {
  private params: ICellEditorParams;
  borderDate: any;
  borderTime: any;
  currentTimeZone: string;

  constructor(private  readonly constants: Constants) {}

  //   @ViewChild('container', { read: ViewContainerRef })
  //   public container!: ViewContainerRef;

  // dont use afterGuiAttached for post gui events - hook into ngAfterViewInit instead for this
  ngAfterViewInit() { // NOSONAR
    //do nothing
  }

  agInit(params: ICellEditorParams & { currentTimeZone: string }): void {
    this.params = params;
    this.currentTimeZone = params.currentTimeZone;
    this.setDateTime(params.value);
    console.info('params', params);
  }

  getValue(): string {
    return (
      DateTime.fromFormat(
        this.borderDate + ' ' + this.borderTime,
        'yyyy-MM-dd HH:mm',
        { zone: this.constants.timeZones[this.currentTimeZone], setZone: true }
      ).toFormat('MM/dd/yyyy HH:mm') + ` (${this.currentTimeZone})`
    );
  }

  isPopup(): boolean {
    return false;
  }

  setDateTime(dateTime: string): void {
    if (!dateTime) {
      const now = DateTime.now().setZone(this.constants.timeZones[this.currentTimeZone]);
      this.borderDate = now.toFormat('yyyy-MM-dd');
      this.borderTime = now.toFormat('HH:mm');
      return;
    }
    const input = DateTime.fromFormat(
      dateTime.substring(0, 16),
      'MM/dd/yyyy HH:mm',
      { zone: this.constants.timeZones[this.currentTimeZone], setZone: true }
    );
    this.borderDate = input.toFormat('yyyy-MM-dd');
    this.borderTime = input.toFormat('HH:mm');
  }

  onKeyDown(event: any): void {
    const key = event.key;
    if ( key == 'ArrowLeft' ||  key == 'ArrowRight' ) {  // NOSONAR
      // right
      event.stopPropagation();
    }
  }

  onChange(_event: any) {
    console.info('date', this.borderDate, '...time', this.borderTime);
  }
}
